import {
  UPDATE_USER_DETAILS,
  UPDATE_SELECTED_BSA,
  UPDATE_LEVEL,
  UPDATE_SELECTED_COUNTRYCODE,
  UPDATE_DT_ACCESS,
  ADD_CHANGED_OUTLETSTATUS,
  REMOVE_CHANGED_OUTLETSTATUS,
  CLEAR_CHANGED_OUTLETSTATUSES,
  UPDATE_UCUBE_ACCESS,
  UPDATE_OPSREPORT_ACCESS,
  UPDATE_ADMIN_ACCESS,

} from "./storeActionTypes";

export const updateUserDetailsAction = details => {
  return {
    type: UPDATE_USER_DETAILS,
    payload: {
      userDetails: details,
    },
  };
};

export const updateSelectedBsaAction = bsa => {
  return {
    type: UPDATE_SELECTED_BSA,
    payload: {
      selectedBsa: bsa,
    },
  };
};

export const updateLevelAction = level => {
  return {
    type: UPDATE_LEVEL,
    payload: {
      level: level,
    },
  };
};

export const updateSelectedCountryCodeAction = countryCode => {
  console.log("111111", countryCode);
  return {
    type: UPDATE_SELECTED_COUNTRYCODE,
    payload: {
      selectedCountryCode: countryCode,
    },
  };
};

export const updateDTAccessAction = dtAccess => {
  return {
    type: UPDATE_DT_ACCESS,
    payload: {
      dtAccess,
    },
  };
};

export const updateAdminAccessAction = admin => {
  return {
    type: UPDATE_ADMIN_ACCESS,
    payload: {
      adminAccess: admin,
    },
  };
};

export const updateUcubeAccessAction = uCube => {
  return {
    type: UPDATE_UCUBE_ACCESS,
    payload: {
      ucubeAccess: uCube,
    },
  };
};

export const updateOpsReportAccessAction = opsReport => {
  console.log("opsReport", opsReport);
  return {
    type: UPDATE_OPSREPORT_ACCESS,
    payload: {
      opsReportAccess: opsReport,
    },
  };
};

export const addChangedStatus = status => {
  return {
    type: ADD_CHANGED_OUTLETSTATUS,
    payload: status,
  };
};

export const removeChangedStatus = outletCode => {
  return {
    type: REMOVE_CHANGED_OUTLETSTATUS,
    payload: outletCode,
  };
};

export const clearChangedStatuses = () => {
  return {
    type: CLEAR_CHANGED_OUTLETSTATUSES,
  }
};
